import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EfectivorespuestaPage } from './efectivorespuesta.page';

const routes: Routes = [
  {
    path: '',
    component: EfectivorespuestaPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EfectivorespuestaPageRoutingModule {}
